//Jquery Start
(function($) {
	$(document).on('click', function(event) {
		// Перевірка, чи клік був на .btn_small.slider-nav або на її дочірні елементи
		if (!$(event.target).closest('.btn_small.slider-nav').length) {
			// Якщо клік був на іншому елементі, видаляємо клас "active" з усіх .btn_small.slider-nav
			$('.btn_small.slider-nav').removeClass('active');
		}
	});
	$('.btn_small.slider-nav').click(function(){
		$('.btn_small.slider-nav').removeClass('active');

		$(this).addClass('active');
	});

	// Mobile toogle menu
	$('.mobilelistnav .mob_submenu').after('<div class="sub_menu_btn burslines_menu"> <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.43359 0.65625L5.34375 4.8125C5.45312 4.94922 5.53516 5.11328 5.53516 5.25C5.53516 5.41406 5.45312 5.57812 5.34375 5.71484L1.43359 9.87109C1.1875 10.1445 0.777344 10.1445 0.503906 9.89844C0.230469 9.65234 0.230469 9.24219 0.476562 8.96875L3.97656 5.25L0.476562 1.55859C0.230469 1.28516 0.230469 0.875 0.503906 0.628906C0.777344 0.382812 1.1875 0.382812 1.43359 0.65625Z" fill="#404040"/></svg></div>');
	$('.sub_menu_btn').on('click', function(){
		// $(this).toggleClass('close_sub_menu');
		$(this).prev('ul').toggleClass('active');
		$(this).parent().toggleClass('openlist');
	});
	$('.mob_submenu-listitem--back').on('click', function() {
		$(this).parent().toggleClass('active');
	})
	//Target Window Open
	$('.open_target').on('click', function(){
		$($(this).data('target')).fadeIn().addClass('show');
		$(this).addClass('show');
		return false;
	})
	$('.close_target').on('click', function(){
		$($(this).data('target')).removeClass('show').fadeOut();
		$('.open_target, .mobilebtn').removeClass('show');
		$('body').removeClass('scroll-hidden');
		return false;
	})
	$('.mobilebtn').on('click', function(){
		if($(this).hasClass('show')){
			$($(this).data('target')).removeClass('show').fadeOut()
			$(this).removeClass('show');
			$('body').removeClass('scroll-hidden');
		}else{
			$($(this).data('target')).fadeIn().addClass('show');
			$(this).addClass('show');
			$('body').addClass('scroll-hidden');
		}
		return false;
	});
    //opening parent link
    $('.mobilelistnav__parent-link').on('click', function(e) {
      if($(this).next().is('.mob_submenu')) {
        e.preventDefault();
        $(this).next('.mob_submenu').slideToggle();
      }
    });
	//opening sub menu
	$('.mobilelistnav li a').each(function(){
		if($(this).attr('href') == '/collections/all-products'){
			// $(this).parent().addClass('openlist')
			// $(this).parents('.mob_submenu').slideDown()
			$(this).next('.mob_submenu').slideDown()
			$(this).siblings('.burslines_menu').addClass('close_sub_menu');
		}
	})
    //Sticky head
	// navbar fixed scrolling
    $(window).on("scroll",function () {
		let bodyScroll =  $(window).scrollTop();
		let	navbar = $(".header-sticky");
		if(bodyScroll > 5){
			navbar.addClass("header_appear");
		}else{
			navbar.removeClass("header_appear");
		}
	});
	//nav menu hover add class parrent
	$('.header.nav-megamenu .menu-list>li').hover(function(){
		if($(this).children().hasClass('dropdown-wrapper')){
			$('.header-sticky').addClass('hovered')
		}
	}, function(){
		$('.header-sticky').removeClass('hovered')
	});
	//header counter custom update
	$(".add-to-cart-button").click(function(){
		setTimeout(function() {
			jQuery.getJSON('/cart/update.js', function(cart) {
				if(cart.item_count > 0) {
					$("span.cart-counter").removeClass('hidden');
					$("span.cart-counter").html(cart.item_count);
				}
			});
		}, 700);
	 });
	 //Header search toogle window
	 $('.head-search-btns svg.icon').on('click', function(){
		if($(this).hasClass('modal__toggle-open')){
			$('details-modal.header__search').addClass('show');
			$(this).addClass('hidden')
		}else{
			$('details-modal.header__search').removeClass('show');
			$('.modal__toggle-open').removeClass('hidden')
		}
	 });
	 //Footer mobile menu toggle
	 $('.mobile-toogle-menu .foot-menu-title').on('click', function(){
		if(!$(this).hasClass('active')){
			$(this).next().stop().slideDown();
			$(this).addClass('active')
		}else{
			$(this).removeClass('active')
			$(this).next().stop().slideUp();
		}
	 });
	//Scroll Animation
	$(window).on('scroll', max_scrollanimation);
	function max_scrollanimation() {
		var win_height_padded = $(window).height() * 1.1;
		var scrolled = $(window).scrollTop();
		$(".scrollanimation:not(.animated)").each(function () {
		   var $this     = $(this),
			   offsetTop = $this.offset().top;

		   if (scrolled + win_height_padded > offsetTop) {

				 if ($this.data('timeout')) {
				   window.setTimeout(function(){
					 $this.addClass('animated ' + $this.data('animation'));
				   }, parseInt($this.data('timeout'),10));
				 } else {
				   $this.addClass('animated ' + $this.data('animation'));
				 }

			}

		});
	}


})(jQuery); //END jQuery
